module.exports = __webpack_public_path__ + "static/media/info_icon.faa8a754.svg";